import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

import { FormulaEvaluationResult } from '../../models/formula-result.model';

@Component({
  selector: 'iot-platform-ui-formula-evaluation-result',
  standalone: true,
  imports: [TranslatePipe, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './formula-evaluation-result.component.html',
  styleUrls: ['./formula-evaluation-result.component.scss']
})
export class FormulaEvaluationResultComponent {
  readonly evaluationResult = input<FormulaEvaluationResult | null>(null);
  readonly validResult = input<boolean>(true);
}
